import Vue from 'vue';
import Vuex from 'vuex';
import devices from './modules/devices';
import graphql from './modules/graphql';
import cactusProfile from './modules/cactusProfile';
import expertviewRuleProvider from './modules/expertviewRuleProvider';
import expertviewParams from './modules/expertviewParams';

Vue.use(Vuex);

const storeConfig = {
  modules: {
    devices,
    graphql,
    cactusProfile,
    expertviewRuleProvider,
    expertviewParams
  },

  // the following part is the generic store implementation
  // that does not fit into any separate module
  state: {},
  getters: {},
  actions: {},
  mutations: {}
};

export default new Vuex.Store(storeConfig);
